import React from "react"
import styles from "./styles.scss"
import LoginForm from "./LoginForm"
import { connect } from 'react-redux'
import { login } from 'data/auth'

class LoginPage extends React.Component {
  handleSubmit = values => {
    this.props.login(values)
  }
  
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.loginFormWrapper}>
          <LoginForm submitText="Logga in" onSubmit={this.handleSubmit} />
        </div>
      </div>
    )
  }
}

export default connect(
  null,
  {
    login,
  })(LoginPage)



// WEBPACK FOOTER //
// src/pages/LoginPage/index.jsx